/**
 * Provides a callback function which can be used to get
 * @param url the url to get from
 * @param onCompleted callback that is fired when the get completes successfully
 * @param onError callback that is fired when the get errors
 * @returns {{loading: boolean, error: boolean, getCallback: ((function(*=, *=): Promise<*>))}}
 *
 * loading - true when post is currently happening.
 *
 * error - true when an error has occurred.
 *
 * getCallback - the callback function to get from the preset url, returns a promise which will contain json from the response.
 */
import { useLazyFetch } from "hooks/fetch/useLazyFetch";

export function useLazyFetchGet(
  url,
  onCompleted = undefined,
  onError = undefined
) {
  const { loading, error, fetchCallback } = useLazyFetch(
    url,
    "GET",
    onCompleted,
    onError
  );

  return { loading, error, getCallback: fetchCallback };
}
